export const EVENT_STORAGE_QUOTA_SERVER_ERROR = 'APP-EVENT::EVENT_STORAGE_QUOTA_SERVER_ERROR';

export const EVENT_INSTANCE_EXPIRED = 'APP-EVENT::EVENT_INSTANCE_EXPIRED';

export const EVENT_ADOBE_EXPRESS_EDIT_RETRY = 'APP-EVENT::EVENT_ADOBE_EXPRESS_EDIT_RETRY';
